<template>
  <div class="audienceCenter">
    <div class="userInfo">
      <!-- content -->
      <div class="exhibitor">
        <div class="exhibitorContent_left">
          <div class="ul_title">
            <ul>
              <li class="li_a" v-for="(item,index) in tabList" :key="index" @click="liSwitch(item)">
                <p class="line-p" v-if="item.name === currentTab"></p>
                {{ item.title }}
              </li>
            </ul>
          </div>
          <el-button class="tc_btn" @click="backHome">退出</el-button>
        </div>
        <div class="exhibitorContent_right">
          <a-home v-if="currentTab === 'AHome'"></a-home>
          <a-info v-if="currentTab === 'AInfo'"></a-info>
          <a-question v-if="currentTab === 'AQuestion'"></a-question>
          <a-add-member v-if="currentTab === 'AAddMember'"></a-add-member>
          <a-update-pws v-if="currentTab === 'AUpdatePws'"></a-update-pws>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AHome from "./AHome";
import AInfo from "./AInfo";
import AQuestion from "./AQuestion";
import AAddMember from "./AAddMember";
import AUpdatePws from "./AUpdatePws";
export default {
  components: {
    AHome,
    AInfo,
    AQuestion,
    AAddMember,
    AUpdatePws,
  },
  mounted() {},
  data() {
    return {
      currentTab: "AHome",
      tabList: [
        { title: "首页", url: "/AHome", name: "AHome" },
        {
          title: "个人信息",
          url: "/AInfo",
          name: "AInfo",
        },
        {
          title: "调查问卷",
          url: "/AQuestion",
          name: "AQuestion",
        },
        {
          title: "添加组员",
          url: "/AAddMember",
          name: "AAddMember",
        },
        {
          title: "修改密码",
          url: "/AUpdatePws",
          name: "AUpdatePws",
        },
      ],
    };
  },
  methods: {
    backHome() {
      this.$confirm("确认退出吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          //确认退出后 删除浏览器session,删除token状态,返回至登录页.
          // sessionStorage.removeItem("gzToken");
          this.$cookie.delete("gzToken");
          this.$store.commit("SET__TOKEN", "");
          this.$store.commit("SET_GZ_USER_INFO", {});
          this.$router.replace("/audLogin");
        })
        .catch(() => {});
    },

    liSwitch(item) {
      this.currentTab = item.name;
    },
  },

  // beforeRouteLeave(to, form, next) {},
};
</script>
<style lang="scss">
.el-message-box__btns button:nth-child(2) {
   background-color: #143372;
   border-color: #143372;
 }
 .el-message-box__btns button:nth-child(1) {
  &:hover {
    background-color: #ffffff;
    color: #606266;
    border-color: #DCDFE6;
  }
 }
</style>
<style lang="scss" scoped>
.audienceCenter {
  width: 100%;
  .userInfo {
    width: 1200px;
    margin: 0 auto;
  }

  // content
  .exhibitor {
    width: 100%;
    .exhibitorContent_left {
      width: 258px;
      height: 751px;
      float: left;
      .ul_title {
        width: 100%;
        height: 260px;
        border: 1px solid #e5e5e5;
        border-radius: 4px;
        margin-bottom: 20px;
        .li_a {
          width: 228px;
          height: 52px;
          line-height: 52px;
          font-size: 14px;
          color: #333333;
          position: relative;
          padding-left: 30px;
          cursor: pointer;
          &:hover {
            background-color: #143372;
            color: #ffffff;
          }
        }
        // 点击不同按钮添加的高亮
        .line-p {
          width: 3px;
          height: 32px;
          background-color: #143372;
          position: absolute;
          top: 10px;
          left: 0;
        }
      }
      .tc_btn {
        width: 200px;
        height: 50px;
        background-color: #143372;
        color: #ffffff;
        font-size: 14px;
        margin: 0 auto;
        margin-left: 30px;
      }
    }
    .exhibitorContent_right {
      width: 920px;
      min-height: 693px;
      margin-bottom: 81px;
      float: right;
      box-shadow: 0px 0px 10px 8px #f3f3f3;
    }
    .el-message-box__btns button:nth-child(2) {
      background-color: #143372;
    }
  }
}
</style>